<div class="container">
  <div class="row">
    <div class="col" style="margin: 15px 0;">
      <p><strong>Полное наименование:</strong> Общество с ограниченной ответственностью «Эвномия Аудит»</p>
      <p><strong>Сокращенное наименование:</strong>c</p>
      <p><strong>Организационно-правовая форма:</strong> Общество с ограниченной ответственностью</p>
      <p><strong>Государственная регистрация:</strong> запись в Единый государственный реестр юридических лиц внесена
        30.01.2013 года, присвоен ОГРН 1137746061166</p>
      <p>Член Саморегулируемой организации аудиторов Ассоциации «Содружество» (СРО ААС).</p>
      <p>Включена в реестр аудиторов и аудиторских организаций 27 февраля 2020 года за основным
        регистрационным номером 12006074406</p>
     <p> Уставный капитал 100 000 рублей.</p>
      <p><strong>Местонахождение:</strong> 115114, Москва г, 1-й Кожевнический переулок, дом 6, строение 1, офис 23</p>
      <p><strong>Номер телефона:</strong> +7 905 795 27 37</p>
      <p><strong>Адрес электронной почты:</strong> nataly@eunomia.ru</p>

      <h4>Актуальные данные по состоянию на 01.01.2026 года:</h4>
      <ul>
        <li>В штате Общества состоят четыре аудитора, один из которых – внешнее совместительство.</li>
        <li>Общая выручка составила 6 800 тыс. рублей, их них аудит – 1 350 тыс. рублей.</li>
      </ul>
    </div>
  </div>
</div>
